import {Transition} from 'framer-motion';

export const DOWNLOAD_APP_URL =
  'https://modak.go.link/?adj_t=18ulf3ni_185bffmo';
export const AUTHENTICATION_DOWNLOAD_APP_URL = 'https://modak.go.link/fGsGh';
export const PARENT_DOWNLOAD_APP_URL = 'https://modak.go.link/4Ivij';
export const KID_DOWNLOAD_APP_URL = 'https://modak.go.link/55Ns9';

export const MODAK_MAKER_REGISTER_URL = 'https://www.modakmakers.com/register';
export const MODAK_MAKER_MBX_POLICY_URL =
  'https://www.modakmakers.com/promos/mobucks-mbx-policy';
export const AUTHENTICATION_PATH = 'authentication';

export const NOTIFY_ME_PATH = 'notify-me';
export const YOUR_INFO_IS_IN_REVIEW_PATH = 'your-info-is-in-review';

// Animations
export const TIME_OUT_ANIMATION = 200;
export const INITIAL_ANIMATION = {y: '100%', opacity: 0};
export const ANIMATION = {y: 0, opacity: 1};
export const EXIT_ANIMATION = {y: '100%', opacity: 0};
export const TRANSITION_ANIMATION: Transition = {
  type: 'spring',
  stiffness: 60,
  damping: 15,
};
